import { get, head } from 'lodash-es'

import AIMEOS_GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'

export const basketServiceCompare = ({ getters }) => {
  return (
    getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED].length === 1 &&
    getters[AIMEOS_GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED].length === 1 &&
    getters[AIMEOS_GETTER_TYPES.SERVICE_PAYMENT_SERVICE_CODE] ===
      get(head(getters[AIMEOS_GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED]), [
        'attributes',
        'order.base.service.code',
      ]) &&
    getters[AIMEOS_GETTER_TYPES.SERVICE_DELIVERY_SERVICE_CODE] ===
      get(head(getters[AIMEOS_GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED]), [
        'attributes',
        'order.base.service.code',
      ])
  )
}
